import { ReloadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Tabs } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../../commons/BackButton";
import { ROOT_URL } from "../../../constants/api";
import { nofication } from "./../../../commons/Nofication";
import Upload from "./../../../commons/Upload";
import BannerForm from "./../../../components/form/bannerForm";
import MainLayout from "./../../../components/mainLayout";
import { authApis } from "./../../../services/authApi";
import "./index.scss";
import InvestorForm from "./../../../components/form/investorForm";

const { TabPane } = Tabs;
const onChange = (key) => {
    console.log(key);
};
const Register = () => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [fileBannerList, setFileBannerList] = useState();
    const [imageBannerUrl, setImageBannerUrl] = useState();
    const [isCheckRemoveBannerImg, setIsCheckRemoveBannerImg] = useState(false);
    const [content, setContent] = useState({
        content_vi: "",
        content_en: "",
        content_kr: "",
        content_cn: "",
        content_jp: "",
    });
    const [form] = Form.useForm();
    let { id } = useParams();

    const onChangeContentValue = (lang) => {};
    useState(() => {
        if (id) {
            authApis
                .getStaticPage(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.banner);
                        form.setFieldsValue({ fields: data.statices });
                        setContent({
                            content_vi: data.banner?.content_vi ?? "<p></p>",
                            content_en: data.banner?.content_en ?? "<p></p>",
                            content_kr: data.banner?.content_kr ?? "<p></p>",
                            content_cn: data.banner?.content_cn ?? '<p></p>',
                            content_jp: data.banner?.content_jp ?? '<p></p>',
                        });
                        setImageUrl(
                            data.banner?.image
                                ? ROOT_URL + data.banner.image
                                : ""
                        );
                        setImageBannerUrl(
                            data.banner?.mapvn
                                ? ROOT_URL + data.banner.mapvn
                                : ""
                        );
                    } else {
                        nofication(
                            "error",
                            "Thất bại",
                            "Vui lòng kiểm tra lại thông tin !"
                        );
                    }
                })
                .catch((errors) => {
                    nofication(
                        "error",
                        "Thất bại",
                        "Không kết nối được server"
                    );
                });
        }
    });

    const onFinish = async () => {
        const values = form.getFieldValue();
        console.log(values);
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (
                key === "content_vi" ||
                key === "content_en" ||
                key === "content_kr" || key === 'content_cn' || key === 'content_jp'
            ) {
                formData.append(
                    key,
                    values[key]?.editor
                        ? values[key]?.editor.getData()
                        : values[key]
                );
            } else {
                formData.append(key, values[key]);
            }
            if (key === "fields") {
                formData.append(key, JSON.stringify(values[key]));
            }
        }
        id && formData.append("id", id);
        formData.append("logo", fileList);
        formData.append("mapvn", fileBannerList);
        formData.append("imageUrl", imageUrl);
        formData.append("imageBannerUrl", imageBannerUrl);

        formData.append("isCheckRemoveBannerImg", isCheckRemoveBannerImg);
        await authApis
            .addStaticPage(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication("success", "Thành công", "Cập nhật thành công!");
                } else {
                    nofication(
                        "error",
                        "Thất bại",
                        "Vui lòng kiểm tra lại thông tin !"
                    );
                }
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Không kết nối được server");
                console.log(errors);
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Investor"
            link="/investor/"
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                colon={true}
            >
                <Row gutter={16}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <InvestorForm
                                        lang={"vi"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                        isBanner={false}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng anh" key="2">
                                    <InvestorForm
                                        lang={"en"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                        isBanner={false}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <InvestorForm
                                        lang={"kr"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                        isBanner={false}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng trung" key="4">
                                    <InvestorForm lang={'cn'} isBanner={false} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng nhật" key="5">
                                    <InvestorForm lang={'jp'} isBanner={false} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                            </Tabs>
                            <Form.Item label="Banner" colon={true}>
                                <Upload
                                    imageUrl={imageUrl}
                                    setFileList={setFileList}
                                    setImageUrl={setImageUrl}
                                    span={24}
                                />
                            </Form.Item>
                            <Form.Item label="MapVn" colon={true}>
                                <Upload
                                    imageUrl={imageBannerUrl}
                                    setFileList={setFileBannerList}
                                    setImageUrl={setImageBannerUrl}
                                    span={24}
                                    setIsCheckRemoveImg={
                                        setIsCheckRemoveBannerImg
                                    }
                                />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
